import { gql } from '@apollo/client'

export const FRAGMENT_COMPANY_PLAN = gql`
  fragment FragmentCompanyPlan on CompanyPlan {
    id: planId
    languages
    jobPins
    jobPinnedCreators
    jobPinnedPosts
    jobPinnedSubtopics
    jobPinnedTopics
    jobPinnedSavedSearches
    jobFolders
    jobs
    workspaces
    editors
    viewers
  }
`
